import { computed, ref } from 'vue'
import { MutationTypes, useStore } from '@/store'
import { createRandomCode } from '@/utils/common'
import { getImageSize } from '@/utils/image'
import { PPTLineElement, PPTElement, TableCell, TableCellStyle, PPTShapeElement,PPTCodeElement, PPTRectElement,PPTSvgElement,PPTChartElement, ChartOptions, PresetChartType, Slide } from '@/types/slides'
import { ShapePoolItem, SHAPE_PATH_FORMULAS } from '@/configs/shapes'
import { LinePoolItem } from '@/configs/lines'
import { RectPoolItem } from '@/configs/rect'
import { CodePoolItem } from '@/configs/code'
import { CHART_TYPES } from '@/configs/chartTypes'
import useHistorySnapshot from '@/hooks/useHistorySnapshot'
import { message } from 'ant-design-vue'


export default () => {
  const store = useStore()
  const theme = computed(() => store.state.theme)
  const themeColor = computed(() => store.state.theme.themeColor)
  const fontColor = computed(() => store.state.theme.fontColor)
  const VIEWPORT_SIZE = computed(() => store.state.viewportWidth)
  const fontName = computed(() => store.state.theme.fontName)
  const viewportRatio = computed(() => store.state.viewportRatio)
  const creatingElement = computed(() => store.state.creatingElement)
  const slides = computed(() => store.state.slides)
  const slideIndex = computed(() => store.state.slideIndex)
  const viewportWidths = computed(() => store.state.viewportWidth)
  const { addHistorySnapshot} = useHistorySnapshot()
  // 创建（插入）一个元素并将其设置为被选中元素
  const createElement = (element: PPTElement) => {
    if (slides.value[slideIndex.value].elements.length > 200) {
      message.error('每页只能创建200个元素！')
      return
    }
    store.commit(MutationTypes.ADD_ELEMENT, element)
    store.commit(MutationTypes.SET_ACTIVE_ELEMENT_ID_LIST, [element.id])
    store.commit(MutationTypes.SET_HANDLE_ELEMENT_ID, element.id)
    store.commit(MutationTypes.SET_M_MATERIAL_SHOW, false);
    if (creatingElement.value) store.commit(MutationTypes.SET_CREATING_ELEMENT, null)

    setTimeout(() => {
      store.commit(MutationTypes.SET_EDITORAREA_FOCUS, true)
    }, 0)

    addHistorySnapshot()
     
  }
  // 创建（插入）一个组合并将其设置为被选中元素
  const createGroupElement = (element: Slide) => {
    const groupId = createRandomCode()
    element.elements.forEach(ele => {
      ele.groupId = groupId
      ele.id = createRandomCode()
    })
    store.commit(MutationTypes.ADD_GROUP_ELEMENT, element.elements)
    if (creatingElement.value) store.commit(MutationTypes.SET_CREATING_ELEMENT, null)

    setTimeout(() => {
      store.commit(MutationTypes.SET_EDITORAREA_FOCUS, true)
    }, 0)

    addHistorySnapshot()
     
  }
  /**
   * 创建图片元素
   * @param src 图片地址
   */
  const createImageElement = (src: string) => {
    getImageSize(src).then(({ width, height }) => {
      const scale = height / width
      
      if (scale < viewportRatio.value && width > viewportWidths.value) {
        width = viewportWidths.value / 2
        height = (width * scale)
      }
      else if (height > viewportWidths.value * viewportRatio.value) {
        height = (viewportWidths.value * viewportRatio.value) / 2
        width = (height / scale)
      }

      createElement({
        type: 'image',
        id: createRandomCode(),
        src,
        width,
        height,
        left: (viewportWidths.value - width) / 2,
        top: (viewportWidths.value * viewportRatio.value - height) / 2,
        fixedRatio: true,
        rotate: 0,
      })
    })
  }
  /**
 * 创建图片元素
 * @param src 图片地址
 */
  const createCilpSvgElement = (data:any) => {
    const dataURL = ref('')
    const _src = '//file.101dao.com/files/upload/image/202303/9712e30f-07e7-4f3a-90d0-90ccd81d9426.png'
    // 一定要设置为let，不然图片不显示
    const image = new Image();
    // 解决跨域问题
    image.setAttribute('crossOrigin', 'anonymous');
    const imageUrl = 'https:' + _src
    image.src = imageUrl
    // image.onload为异步加载
    image.onload = () => { 
  
    const canvas = document.createElement("canvas");
    canvas.width = image.width;
    canvas.height = image.height;
    const context = canvas.getContext('2d');
    context?.drawImage(image, 0, 0, image.width, image.height);
    const quality = 0.8;
    // 这里的dataurl就是base64类型
    dataURL.value = canvas.toDataURL("image/jpeg", quality);
    getImageSize(_src).then(({ width, height }) => {
      const scale = height / width
      
      if (scale < viewportRatio.value && width > viewportWidths.value) {
        width = viewportWidths.value / 2
        height = (width * scale)
      }
      else if (height > viewportWidths.value * viewportRatio.value) {
        height = (viewportWidths.value * viewportRatio.value) / 2
        width = (height / scale)
      }

      createElement({
        type: 'clip',
        id: createRandomCode(),
        src:_src,
        src64:dataURL.value,
        w:width,
        h:height,
        path:data.path,
        left: (viewportWidths.value - data.width) / 2,
        top: (viewportWidths.value * viewportRatio.value - data.height) / 2,
        width:data.width, 
        height:data.height,
        fixedRatio: true,
        viewBox:data.viewBox,
        viewBoxW: data.width,
        viewBoxH: data.height,
        x:0,
        y:0,
        rotate: 0,
        opacity:1,
      })
    })
    }

  }
  /**
   * 创建图表元素
   * @param chartType 图表类型
   */
  const createChartElement = (type: PresetChartType) => {
    const newElement: PPTChartElement = {
      type: 'chart',
      id: createRandomCode(),
      chartType: CHART_TYPES[type],
      left: 300,
      top: 81.25,
      width: 400,
      height: 400,
      rotate: 0,
      themeColor: [theme.value.themeColor],
      gridColor: theme.value.fontColor,
      data: {
        labels: ['类别1', '类别2', '类别3', '类别4', '类别5'],
        legends: ['系列1'],
        series: [
          [12, 19, 5, 2, 18],
        ],
      },
    }

    let options: ChartOptions = {}
    if (type === 'horizontalBar') options = { horizontalBars: true }
    else if (type === 'area') options = { showArea: true }
    else if (type === 'scatter') options = { showLine: false }
    else if (type === 'ring') options = { donut: true }

    createElement({
      ...newElement,
      options,
    })
  }
  
  /**
   * 创建表格元素
   * @param row 行数
   * @param col 列数
   */
  /**
   * 创建表格元素
   * @param row 行数
   * @param col 列数
   */
  const createTableElement = (row: number, col: number) => {
    const style: TableCellStyle = {
      fontname: theme.value.fontName,
      color: theme.value.fontColor,
      fontsize:theme.value.fontSize
    }
    const data: TableCell[][] = []
    for (let i = 0; i < row; i++) {
      const rowCells: TableCell[] = []
      for (let j = 0; j < col; j++) {
        rowCells.push({ id: createRandomCode(), colspan: 1, rowspan: 1, text: '', style })
      }
      data.push(rowCells)
    }

    const DEFAULT_CELL_WIDTH = 100
    const DEFAULT_CELL_HEIGHT = 36

    const colWidths: number[] = new Array(col).fill(1 / col)

    const width = col * DEFAULT_CELL_WIDTH
    const height = row * DEFAULT_CELL_HEIGHT

    createElement({
      type: 'table',
      id: createRandomCode(),
      width,
      height,
      colWidths,
      rotate: 0,
      data,
      left: (VIEWPORT_SIZE.value - width) / 2,
      top: (VIEWPORT_SIZE.value * viewportRatio.value - height) / 2,
      outline: {
        width: 2,
        style: 'solid',
        color: '#eeece1',
      },
      theme: {
        color: theme.value.themeColor,
        rowHeader: true,
        rowFooter: false,
        colHeader: false,
        colFooter: false,
      },
      cellMinHeight: 36,
    })
  }
  const createCustomTableElement = (data: any) => {
    data.id = createRandomCode()

    createElement(data)
  }
  
  /**
   * 创建文本元素
   * @param position 位置大小信息
   * @param content 文本内容
   */
  const createTextElement = (position: any, content = '双击编辑文字',size = '14px') => {
    const width = viewportWidths.value / 2
    const height = 36
    createElement({
      type: 'text',
      id: createRandomCode(),
      left: (viewportWidths.value - width) / 2,
      top: (viewportWidths.value * viewportRatio.value - height) / 2,
      width, 
      height,
      content,
      rotate: 0,
      fixedRatio: true,
      fill: "#fff",
      fillShow: false,
      fillType: "pure",
      defaultFontName: fontName.value,
      defaultFontSize:size,
      defaultColor: fontColor.value,
    })
  }
  /**
   * 创建svg元素
   * @param position 位置大小信息
   * @param data 形状路径信息
   */
  const createSvgElement = (data: ShapePoolItem) => {
    const newElement: PPTSvgElement = {
      type: 'svg',
      id: createRandomCode(),
      left: (viewportWidths.value - data.width) / 2,
      top: (viewportWidths.value * viewportRatio.value - data.height) / 2,
      width:data.width, 
      height:data.height,
      viewBox:data.viewBox[0],
      viewBoxW: data.viewBox[0],
      viewBoxH: data.viewBox[1],
      path: data.path,
      fill: themeColor.value,
      colors:data.colors,
      fixedRatio: true,
      rotate: 0,
      svg:'',
    }
    if (data.special) newElement.special = true
    createElement(newElement)
  }
  /**
   * 创建形状元素
   * @param position 位置大小信息
   * @param data 形状路径信息
   */
  const createShapeElement = (data: ShapePoolItem) => {
    const newElement: PPTShapeElement = {
      type: 'shape',
      id: createRandomCode(),
      left: (viewportWidths.value - data.width) / 2,
      top: (viewportWidths.value * viewportRatio.value - data.height) / 2,
      width:data.width, 
      height:data.height,
      viewBox:data.viewBox,
      viewBoxW: data.width,
      viewBoxH: data.height,
      path: data.path,
      fill: themeColor.value,
      fixedRatio: true,
      rotate: 0
    }
    if (data.special) newElement.special = true
    if (data.pathFormula) {
      newElement.pathFormula = data.pathFormula
      newElement.viewBox = data.width
      const pathFormula = SHAPE_PATH_FORMULAS[data.pathFormula]
      if ('editable' in pathFormula) {
        newElement.path = pathFormula.formula(data.width, data.height, pathFormula.defaultValue)
        newElement.keypoint = pathFormula.defaultValue
      }
      else newElement.path = pathFormula.formula(data.width, data.height)
    }
    createElement(newElement)
  }
  
  /**
   * 创建线条元素
   * @param position 位置大小信息
   * @param data 线条的路径和样式
   */
  const createLineElement = (data: LinePoolItem) => {
    const start:[number,number] = [0,0]
    const end:[number,number] = [120,80]
    const newElement: PPTLineElement = {
      type: 'line',
      id: createRandomCode(),
      left: (viewportWidths.value - 120) / 2,
      top: (viewportWidths.value * viewportRatio.value - 120) / 2,
      start,
      end,
      points: data.points,
      color: themeColor.value,
      style: data.style,
      width: 2
    }
    if (data.isBroken) newElement.broken = [(start[0] + end[0]) / 2, (start[1] + end[1]) / 2]
    if (data.isCurve) newElement.curve = [(start[0] + end[0]) / 2, (start[1] + end[1]) / 2]
    createElement(newElement)
  }
  /**
   * 创建矩形元素
   * @param position 位置大小信息
   * @param data 形状路径信息
   */
  const createRectElement = (data: RectPoolItem) => {
    const newElement: PPTRectElement = {
      type: 'rect',
      id: createRandomCode(),
      left: (viewportWidths.value - data.width) / 2,
      top: (viewportWidths.value * viewportRatio.value - data.height) / 2,
      radius:data.radius,
      width:data.width, 
      height:data.height,
      fill:themeColor.value,
      stroke:themeColor.value,
      viewBox:data.viewBox,
      strokeWidth:data.strokeWidth,
      strokeDasharray: data.strokeDasharray,
      rotate: data.rotate || 0,
      fixedRatio: true,
    }
    createElement(newElement)
  }
  /**
   * 创建二维码元素
   * @param position 位置大小信息
   * @param data 形状路径信息
   */
  const createCodeElement = (data: CodePoolItem) => {
    const newElement: PPTCodeElement = {
      type: 'code',
      id: createRandomCode(),
      left: (viewportWidths.value - data.width) / 2,
      top: (viewportWidths.value * viewportRatio.value - data.height) / 2,
      rotate: data.rotate || 0,
      imgPath: data.preview,
      content: {type:'url',content:'https://www.101dao.com/'},
      style: {
        bcolor: data.bcolor, // 背景色
        acolor: data.acolor, // 前景色
        dots: data.dots, // 码点样式 (`'rounded' 'dots' 'classy' 'classy-rounded' 'square' 'extra-rounded'`)
        colorStops: data.colorStops,
      },
      width: data.width,
      height: data.height,
      fixedRatio: true,
      fill: 'pure'
    }
    createElement(newElement)
  }

  return {
    createCustomTableElement,
    createImageElement,
    createChartElement,
    createTableElement,
    createTextElement,
    createShapeElement,
    createRectElement,
    createLineElement,
    createGroupElement,
    createSvgElement,
    createCodeElement,
    createCilpSvgElement
  }
}